"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var GraphQLErrorFunctions_1 = require("../../error/functions/GraphQLErrorFunctions");
var TableQueryGql_1 = require("../../queries/TableQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
var CenteredMessage_1 = require("../widgets/CenteredMessage");
var CenteredSpinner_1 = require("../widgets/CenteredSpinner");
var TableQueryWrapper = /** @class */ (function (_super) {
    __extends(TableQueryWrapper, _super);
    function TableQueryWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTableData = function (data) {
            var table = data.tables ? data.tables[0] : null;
            if (table) {
                return _this.props.children(table);
            }
            else {
                return React.createElement(CenteredMessage_1.CenteredMessage, { message: Localize_1.Messages.ErrorItemNotFound() });
            }
        };
        return _this;
    }
    TableQueryWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: TableQueryGql_1.TableQueryGql, variables: { tableId: this.props.tableId } }, function (result) { return renderQueryResult_1.renderQueryResult(result, {
            renderLoading: function () { return React.createElement(CenteredSpinner_1.CenteredFadeInSpinner, null); },
            renderData: _this.renderTableData,
            renderNoData: GraphQLErrorFunctions_1.renderNoData,
            renderDataWithError: GraphQLErrorFunctions_1.createRenderDataWithErrorFunction(_this.renderTableData),
            renderError: GraphQLErrorFunctions_1.renderError,
        }); }));
    };
    return TableQueryWrapper;
}(React.Component));
exports.TableQueryWrapper = TableQueryWrapper;
//# sourceMappingURL=TableQueryWrapper.js.map